import {AppSetting} from "@/components/customers/scripts/types";

const createEmptyAppSettings = () : AppSetting => {
    return {
        apiKey: '',
        apiSecret: '',
        deviceId: '',
        deviceLabel: '',
        deviceName: '',
        serverUri: ''
    };
}

export {
    createEmptyAppSettings
}
